import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
// src/modules/Locations/hooks/useLocationsAndGroups.ts
var testData = {
	locationsAndGroups: [
		{
			color: "rgb(125,156,187)",
			id: "ID_01",
			label: "West Locations",
			regionIds: ["rgn-"],
			type: "Group"
		},
		{
			color: "#d66b1f",
			id: "ID_02",
			label: "East Locations",
			regionIds: ["rgn-"],
			type: "Group"
		},
		{
			color: "#8bdc4a",
			id: "ID_03",
			label: "South Locations",
			regionIds: ["rgn-"],
			type: "Group"
		},
		{
			id: "ID_04",
			label: "Shopping Mall",
			regionIds: ["rgn-"],
			type: "Location"
		},
		{
			id: "ID_05",
			label: "Dry Docks",
			regionIds: ["rgn-"],
			type: "Location"
		}
	],
	total: 5
};
function useLocationsAndGroups(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationsAndGroupsLabelsList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args,
		testData
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
export { useLocationsAndGroups };

//# sourceMappingURL=useLocationsAndGroups.js.map